import { aboutFeatures } from "@/mocks/homeData";

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="text-sm font-bold text-primary-600">
              认识奇妙漫画网
            </span>
            <h2 className="font-heading mt-2 text-2xl text-foreground-950 md:text-4xl">
              为什么大家爱在这里看短篇？
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              我们相信，一个好故事不需要很长。奇妙漫画网专注于精选脑洞短篇与创意短篇漫画，帮你在繁忙的生活里，用几分钟时间收获一段奇思妙想。每一篇都经过编辑的认真审读，节奏紧凑、反转有力、回味悠长。
            </p>
            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {aboutFeatures.map((f) => (
                <div
                  key={f.title}
                  className="flex items-start gap-3 rounded-xl border border-background-200 bg-background-100 p-4"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                    <i className={`${f.icon} text-lg`} />
                  </span>
                  <div>
                    <h4 className="font-heading text-base text-foreground-950">
                      {f.title}
                    </h4>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">
                      {f.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=hand-drawn%20whimsical%20storybook%20illustration%20of%20a%20cozy%20reading%20corner%20with%20stacked%20comic%20books%2C%20lamps%2C%20and%20floating%20stars%20in%20the%20air%2C%20warm%20cream%20background%2C%20coral%20orange%20and%20teal%20green%20flat%20color%20palette%2C%20clean%20modern%20vector%20art%20style&width=1000&height=820&seq=qm-about&orientation=portrait"
              alt="奇妙漫画网温馨阅读场景插画"
              className="aspect-[5/4] w-full rounded-3xl object-cover object-top"
            />
            <div className="absolute -bottom-5 left-6 flex items-center gap-3 rounded-2xl border border-background-200 bg-background-50 px-5 py-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                <i className="ri-heart-3-fill text-lg" />
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-950">
                  98% 读者好评
                </p>
                <p className="text-xs text-foreground-600">
                  超过 1200 篇精选短篇
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}